const toastr = require('toastr');

// Set configuration immediately and ensure it stays
toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": false,
    "positionClass": "toast-top-center",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "1500",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};

// Keep toastr within the iframe but position it optimally

// Force toastr container to be positioned relative to the main window, not iframe
const originalClear = toastr.clear;
toastr.clear = function(toast, clearOptions) {
    const result = originalClear.call(this, toast, clearOptions);
    
    // After clearing, ensure the container is properly positioned
    setTimeout(() => {
        const container = document.getElementById('toast-container');
        if (container) {
            container.style.position = 'fixed';
            container.style.top = '12px';
            container.style.left = '50%';
            container.style.transform = 'translateX(-50%)';
            container.style.width = '300px';
            container.style.margin = '0 auto';
            container.style.zIndex = '999999';
        }
    }, 0);
    
    return result;
};

// Override toastr methods to ensure configuration is always applied
const originalInfo = toastr.info;
const originalSuccess = toastr.success;
const originalWarning = toastr.warning;
const originalError = toastr.error;

toastr.info = function(message, title, options) {
    // Always use current window's toastr to ensure content is displayed
    toastr.options.positionClass = "toast-top-center";
    const result = originalInfo.call(this, message, title, options);
    
    // Force container positioning after toast is created
    setTimeout(() => {
        const container = document.getElementById('toast-container');
        if (container) {
            // Always keep toastr in iframe but position it optimally for visibility
            container.style.position = 'fixed';
            container.style.top = '60px';
            container.style.left = '50%';
            container.style.transform = 'translateX(-50%)';
            container.style.width = '300px';
            container.style.margin = '0 auto';
            container.style.zIndex = '2147483647';
            container.style.pointerEvents = 'auto';
            container.className = 'toast-top-center';
            
            // Ensure toast content is visible - check multiple times with delays
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block';
                    toast.style.visibility = 'visible';
                    toast.style.opacity = '1';
                    // Force text content to be visible
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block';
                        toastText.style.visibility = 'visible';
                        toastText.style.opacity = '1';
                        toastText.style.color = '#333';
                    }
                });
            }, 100);
            
            // Double-check after a longer delay
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block !important';
                    toast.style.visibility = 'visible !important';
                    toast.style.opacity = '1 !important';
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block !important';
                        toastText.style.visibility = 'visible !important';
                        toastText.style.opacity = '1 !important';
                        toastText.style.color = '#333 !important';
                    }
                });
            }, 500);
        }
    }, 0);
    
    return result;
};

toastr.success = function(message, title, options) {
    // Always use current window's toastr to ensure content is displayed
    toastr.options.positionClass = "toast-top-center";
    const result = originalSuccess.call(this, message, title, options);
    
    setTimeout(() => {
        const container = document.getElementById('toast-container');
        if (container) {
            // Always keep toastr in iframe but position it optimally for visibility
            container.style.position = 'fixed';
            container.style.top = '60px';
            container.style.left = '50%';
            container.style.transform = 'translateX(-50%)';
            container.style.width = '300px';
            container.style.margin = '0 auto';
            container.style.zIndex = '2147483647';
            container.style.pointerEvents = 'auto';
            container.className = 'toast-top-center';
            
            // Ensure toast content is visible - check multiple times with delays
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block';
                    toast.style.visibility = 'visible';
                    toast.style.opacity = '1';
                    // Force text content to be visible
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block';
                        toastText.style.visibility = 'visible';
                        toastText.style.opacity = '1';
                        toastText.style.color = '#333';
                    }
                });
            }, 100);
            
            // Double-check after a longer delay
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block !important';
                    toast.style.visibility = 'visible !important';
                    toast.style.opacity = '1 !important';
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block !important';
                        toastText.style.visibility = 'visible !important';
                        toastText.style.opacity = '1 !important';
                        toastText.style.color = '#333 !important';
                    }
                });
            }, 500);
        }
    }, 0);
    
    return result;
};

toastr.warning = function(message, title, options) {
    // Always use current window's toastr to ensure content is displayed
    toastr.options.positionClass = "toast-top-center";
    const result = originalWarning.call(this, message, title, options);
    
    setTimeout(() => {
        const container = document.getElementById('toast-container');
        if (container) {
            // Always keep toastr in iframe but position it optimally for visibility
            container.style.position = 'fixed';
            container.style.top = '60px';
            container.style.left = '50%';
            container.style.transform = 'translateX(-50%)';
            container.style.width = '300px';
            container.style.margin = '0 auto';
            container.style.zIndex = '2147483647';
            container.style.pointerEvents = 'auto';
            container.className = 'toast-top-center';
            
            // Ensure toast content is visible - check multiple times with delays
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block';
                    toast.style.visibility = 'visible';
                    toast.style.opacity = '1';
                    // Force text content to be visible
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block';
                        toastText.style.visibility = 'visible';
                        toastText.style.opacity = '1';
                        toastText.style.color = '#333';
                    }
                });
            }, 100);
            
            // Double-check after a longer delay
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block !important';
                    toast.style.visibility = 'visible !important';
                    toast.style.opacity = '1 !important';
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block !important';
                        toastText.style.visibility = 'visible !important';
                        toastText.style.opacity = '1 !important';
                        toastText.style.color = '#333 !important';
                    }
                });
            }, 500);
        }
    }, 0);
    
    return result;
};

toastr.error = function(message, title, options) {
    // Always use current window's toastr to ensure content is displayed
    toastr.options.positionClass = "toast-top-center";
    const result = originalError.call(this, message, title, options);
    
    setTimeout(() => {
        const container = document.getElementById('toast-container');
        if (container) {
            // Always keep toastr in iframe but position it optimally for visibility
            container.style.position = 'fixed';
            container.style.top = '60px';
            container.style.left = '50%';
            container.style.transform = 'translateX(-50%)';
            container.style.width = '300px';
            container.style.margin = '0 auto';
            container.style.zIndex = '2147483647';
            container.style.pointerEvents = 'auto';
            container.className = 'toast-top-center';
            
            // Ensure toast content is visible - check multiple times with delays
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block';
                    toast.style.visibility = 'visible';
                    toast.style.opacity = '1';
                    // Force text content to be visible
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block';
                        toastText.style.visibility = 'visible';
                        toastText.style.opacity = '1';
                        toastText.style.color = '#333';
                    }
                });
            }, 100);
            
            // Double-check after a longer delay
            setTimeout(() => {
                const toasts = container.querySelectorAll('.toast');
                toasts.forEach(toast => {
                    toast.style.display = 'block !important';
                    toast.style.visibility = 'visible !important';
                    toast.style.opacity = '1 !important';
                    const toastText = toast.querySelector('.toast-message');
                    if (toastText) {
                        toastText.style.display = 'block !important';
                        toastText.style.visibility = 'visible !important';
                        toastText.style.opacity = '1 !important';
                        toastText.style.color = '#333 !important';
                    }
                });
            }, 500);
        }
    }, 0);
    
    return result;
};

// Debug: Log the configuration to console
console.log('Toastr configured with positionClass:', toastr.options.positionClass);
console.log('Toastr methods overridden to ensure top-center positioning');

module.exports = toastr;



// WEBPACK FOOTER //
// ./app/helpers/toastr-config.js